<script lang="ts">
    import {currentPage,currentUser} from './store'
    const Go = (page:string) =>{    
        $currentPage = page;
    }
</script>

<nav>
    <button on:click="{()=>Go("Home")}">Home</button>
    {#if $currentUser}
    <button on:click="{()=>Go("Typing")}">Practice</button>
    <button on:click="{()=>Go("Add")}">Add New</button>
    {/if}
    <button on:click="{()=>Go("About")}">About</button>
</nav>

